import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription, interval } from 'rxjs';
import { idleTimeoutConfig } from './idleTimeout.constants';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit, OnDestroy {

  count = idleTimeoutConfig.timeToCancelCountDown ;
  subiscription: Subscription = new Subscription()

  constructor(
    private dialogRef: MatDialogRef<LogoutComponent>,
  ) {}

  continueSession(): void {
    this.dialogRef.close(true)
  }

  formatText(time: number): string {
    let min = Math.trunc(time / 60);
    let sec = Math.trunc(time % 60);
    let minutes = min < 10 ? '0' + min : min;
    let seconds = sec < 10 ? '0' + sec : sec;

    let duration = `${minutes}:${seconds}`;

    return duration
  }

  ngOnInit(): void {
    this.startCountdown();
  }


  startCountdown() {
    this.subiscription.add(interval(1000).subscribe(() => {
      this.count--;

      if (this.count === 0) {
        this.stopCountdown();
        this.dialogRef.close(false)
      }
    }))
  }

  stopCountdown(): void {
    if (this.subiscription) {
      this.subiscription.unsubscribe();
    }
  }

  ngOnDestroy(): void {
    this.stopCountdown();
  }

}
